import script from "./PasswordResetSuccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetSuccessView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetSuccessView.vue?vue&type=style&index=0&id=0b12d272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b12d272"]])

export default __exports__